

/**
 * The base breakpoints for the   Material.
 * You can add new breakpoints using this file.
 * You can customized the breakpoints for the entire   Material using thie file.
 */

export default {
  values: {
    xs: 375,
    sm: 425,
    md: 768,
    lg: 1024,
    xl: 1440,
    xxl: 1680,
  },
};
